export const typeItems = [
  {
    key: 'TEXT',
    title: 'customField.type.text.title',
    description: 'customField.type.text.desc',
    icon: 'icon-outline_plus',
    isShow: true,
  },
  {
    key: 'NUMERIC',
    title: 'customField.type.numeric.title',
    description: 'customField.type.numeric.desc',
    icon: 'icon-outline_plus',
    isShow: true,
  },
  {
    key: 'TIMESTAMPTZ',
    title: 'customField.type.datetime.title',
    description: 'customField.type.datetime.desc',
    icon: 'icon-outline_calendar',
    isShow: true,
  },
]